var map = {
	"./continuous_improvement.png": 81,
	"./creating_kindness_for_cust.png": 82,
	"./developing_business.png": 83,
	"./developing_paragonian.png": 84,
	"./education_health.png": 85,
	"./grow_together.png": 86,
	"./preserving_the_earth.png": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1340;